/* fs-megamenu.js — hover image for the desktop dropdown.
   Reads the key -> image map emitted by snippets/fs-menu-images.liquid and
   stages one <img> per submenu link on the right of the open panel. Images
   come from each collection's or product's featured image, or each blog's
   custom.menu_image metafield, in Shopify admin — so this file never needs
   editing when an image changes.

   Images carry data-src and are only fetched once the pointer reaches the nav
   bar, so a menu nobody touches costs nothing on page load. The warm trigger
   must sit on .navigation--left (the VISIBLE proxy bar) — the panels live in
   .navigation--main, which is visibility:hidden and never receives a hover. */
(function () {
  /* Must build the SAME key shape the Liquid map uses:
       /collections/<h>  ->  "<h>"
       /products/<h>     ->  "product:<h>"
       /blogs/<h>        ->  "blog:<h>"
     Product and blog keys are namespaced so a collection, a product and a
     blog sharing a handle cannot collide. Before 2026-09-01 this only read
     /collections/, which is why E-Gift Card — the one product link in the
     Shop menu — showed no image. Blogs were added 2026-09-03 for the three
     Magazine links (Films, Events, Articles).

     An article URL is /blogs/<blog>/<article>; taking split('/')[0] means an
     article link resolves to its parent blog's image rather than dropping
     out of the map. */
  function keyOf(href) {
    if (!href) return null;
    var i = href.indexOf('/collections/');
    if (i !== -1) {
      var c = href.slice(i + 13).split('?')[0].split('#')[0].split('/')[0];
      return c || null;
    }
    var j = href.indexOf('/products/');
    if (j !== -1) {
      var p = href.slice(j + 10).split('?')[0].split('#')[0].split('/')[0];
      return p ? 'product:' + p : null;
    }
    var k = href.indexOf('/blogs/');
    if (k !== -1) {
      var b = href.slice(k + 7).split('?')[0].split('#')[0].split('/')[0];
      return b ? 'blog:' + b : null;
    }
    return null;
  }

  function init() {
    var el = document.getElementById('fs-menu-images');
    if (!el) return;

    var map;
    try {
      map = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!map || !Object.keys(map).length) return;

    var panels = document.querySelectorAll('.navigation--main .navigation__tier-2-container');
    var warmers = [];

    Array.prototype.forEach.call(panels, function (panel) {
      var container = panel.querySelector('.container');
      var list = panel.querySelector('.navigation__tier-2');
      if (!container || !list || panel.querySelector('.fs-menu-stage')) return;

      var links = list.querySelectorAll(':scope > .navigation__item > .navigation__link');
      if (!links.length) return;

      var stage = document.createElement('div');
      stage.className = 'fs-menu-stage';
      stage.setAttribute('aria-hidden', 'true');

      var entries = [];
      var firstWithImage = -1;
      var warmed = false;

      Array.prototype.forEach.call(links, function (a) {
        var data = map[keyOf(a.getAttribute('href'))] || null;
        var img = null;

        if (data) {
          img = document.createElement('img');
          img.className = 'fs-menu-stage__img';
          img.setAttribute('data-src', data.src);
          img.alt = '';
          img.decoding = 'async';
          stage.appendChild(img);
          if (firstWithImage === -1) firstWithImage = entries.length;
        }

        var index = entries.length;
        entries.push({ link: a, img: img });

        a.addEventListener('mouseenter', function () { warm(); show(index); });
        a.addEventListener('focus', function () { warm(); show(index); });
      });

      // Nothing in this panel has an image — don't stage anything.
      if (firstWithImage === -1) return;

      function warm() {
        if (warmed) return;
        warmed = true;
        for (var i = 0; i < entries.length; i++) {
          var img = entries[i].img;
          if (img && !img.src) img.src = img.getAttribute('data-src');
        }
      }

      function show(index) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].img) continue;
          entries[i].img.classList.toggle('is-visible', i === index);
        }
      }

      container.appendChild(stage);
      show(firstWithImage);
      list.addEventListener('mouseleave', function () { show(firstWithImage); });
      warmers.push(warm);
    });

    if (!warmers.length) return;

    function warmAll() {
      for (var i = 0; i < warmers.length; i++) warmers[i]();
    }

    var bar = document.querySelector('.navigation--left');
    if (bar) {
      bar.addEventListener('mouseenter', warmAll, { once: true });
      bar.addEventListener('focusin', warmAll, { once: true });
    }

    // Backstop for touch/keyboard paths that never fire a nav hover.
    if (window.requestIdleCallback) {
      window.requestIdleCallback(warmAll, { timeout: 6000 });
    } else {
      window.setTimeout(warmAll, 4000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
